import React, { Component } from 'react';
import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';
import { Button } from '@common/components/Button';
import { FormControl } from '@common/components/form-control';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';

import '../styles/FormatCreate.scss';

export default class FormatCreate extends Component {
    static propTypes = {
        close: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
    };

    state = {
        name: '',
    };

    onChange = (e) => {
        e.persist();
        this.setState((state) => ({ ...state, name: e.target.value }));
    }

    onBlur = (e) => {
        e.persist();
        this.setState((state) => ({ ...state, name: e.target.value.trim() }));
    }
    
    onSubmit = () => {
        this.props.onSubmit(this.state.name);
    }

    render() {
        const { close } = this.props;
        const { name } = this.state;

        return (
            <Modal 
                show
                backdrop="static"
                bsClass="bootstrap modal"
                className="FormatCreate"
                dialogClassName="FormatCreate__dialog"
                animation={false}
                onEscapeKeyDown={close}
                onHide={close}
            >
                <ModalHeader closeButton onHide={close} className="FormatCreate__header">
                    <ModalTitle id="format-create-header">{I18n.t('New User Profile Format')}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="FormatCreate__content">
                        <div className="FormatCreate__content__input-wraper">
                            <label id="lbl-pc-profile-name" htmlFor="Profile-name">{I18n.t('Profile Name')}:</label>
                            <FormControl
                                id="Profile-name" 
                                value={name} 
                                onChange={this.onChange}
                                onBlur={this.onBlur}
                            />
                        </div>

                        <div className="FormatCreate__content__controls">
                            <Button id="btn-pc-add" disabled={!name} onClick={this.onSubmit}>{I18n.t('Add')}</Button>
                            <Button id="btn-pc-cancel" onClick={close}>{I18n.t('Cancel')}</Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}